import { createApp } from 'vue'
import App from './App.vue'
import { Button, CellGroup, Field, Form, Icon } from 'vant'

// 1. 引入 Pinia
import { createPinia } from 'pinia'

// 2. 引入路由
import router from '@/router'

// 3. 引入 Vant 样式
import 'vant/lib/index.css'

// 4. 引入 flexible 适配
import 'amfe-flexible'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(Button)
app.use(Form)
app.use(Field)
app.use(CellGroup)
app.use(Icon)
app.mount('#app')
